import { useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import { forgetUser, resetProfile } from '../../utils/api';

import './Forget.css';

function Forget({ handleError }) {
  const { logout } = useAuth0();

  const handleForget = useCallback(async () => {
    try {
      const response = await forgetUser();

      if (response?.status === 'user_deleted') {
        resetProfile();
        logout({
          logoutParams: {
            returnTo: window.location.origin
          }
        });
      }
    } catch (e) {
      handleError(e);
    }
  }, [handleError, logout]);

  return (
    <div id="forget-container" className="popup-overlay">
      <div className="popup">
        <div className="popup-title">Forget Me</div>
        <p>This will permanently delete your account and all associated data.</p>
        <p>This action cannot be undone.</p>
        <div className="actions">
          <div className="action action-secondary" onClick={() => window.location = '/'}>Cancel</div>
          <div className="action action-primary" onClick={handleForget}>Forget Me</div>
        </div>
      </div>
    </div>
  );
}

export default Forget;